/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-useless-constructor */
/* eslint-disable max-len */
import React from 'react'
import { connect } from 'react-redux'
import { Flex, Text, Pane, Content } from '@leverege/ui-elements'
import { TitleBar } from '@leverege/ui-plugin'
import I18N from '@leverege/i18n'
import classes from './Classes.css'

const screenIcon = 'https://storage.googleapis.com/prd-generic-kudelski-ui-assets/Screen%20Icons/screen-integrations-blue.svg'
const errorImage = 'https://molten-ui-assets.storage.googleapis.com/forbidden.png'

const { t } = I18N.ns( 'molten.screens.account.IntegrationsScreen' )

class IntegrationsScreen extends React.Component {

  constructor( props ) {
    super( props )
  }

  componentDidMount() {}

  render() {
    return (
      <Content>
        <Content.Header>
          <TitleBar 
            variant="screenTitle" 
            title="Integrations"
            icon={screenIcon}/>
        </Content.Header>
        <Content.Area>
          <Pane className={classes.errorScreenContent}>            
            <img className={classes.errorScreenImage} src={errorImage} alt="Integrations Error" />
            <Flex variant="colM" className={classes.errorScreenTextColumn} >
              <Text style={{ fontSize : '20px', fontWeight : 700 }}>Integrations Error</Text>
              <Text>Looks like there was an error in integrating with John Deere. Please try again.</Text>
            </Flex>
          </Pane>
        </Content.Area>
      </Content>
    )
  }
}

export default connect(
  state => ( {
    auth : state.auth,
    users : state.users
  } )
)( IntegrationsScreen )
